// Maps a backend status string (agent runs, connectors, audited answers, …) to
// the design system's badge tone, so every page colours the same state the
// same way. Unknown statuses fall back to the neutral badge.
const STATUS_TONES = {
  success: ["ok", "complete", "completed", "succeeded", "success", "done", "approved", "accepted"],
  info: ["running", "pending", "queued", "syncing", "processing", "direct", "waiting", "in_review"],
  warning: ["awaiting_approval", "sent_back", "dropped","may_be_incomplete", "stopped", "cancelled", "canceled", "expired", "no_sources", "partial", "denied"],
  danger: ["failed", "failure", "error", "rejected"],
};

const TONE_BY_STATUS = Object.fromEntries(
  Object.entries(STATUS_TONES).flatMap(([tone, statuses]) => statuses.map((s) => [s, tone])));

export function statusTone(status) {
  return TONE_BY_STATUS[String(status || "").toLowerCase()] || null;
}

export function statusBadgeClass(status) {
  const tone = statusTone(status);
  return tone ? `ds-badge ds-badge--${tone}` : "ds-badge";
}

/** Human-readable label for a snake_case status ("awaiting_approval" → "awaiting approval"). */
export function statusLabel(status) {
  return String(status || "").replace(/_/g, " ");
}
